<template>
  <div class="c-study-video">
    <div id="c-study-video-wrapper" class="m">
      <div v-if="showAutoNext && next" class="c-study-video-autoNext">
        <p class="c-study-video-autoNext-info">
          下一节课程：{{next.title}}
          <span v-if="next.video_time" class="c-study-video-autoNext-length">({{next.video_time}})</span>
        </p>
        <button class="c-study-video-autoNext-btn" @click="$emit('next')">下一节</button>
        <p class="c-study-video-autoNext-count">5秒后进入下一节</p>
        <p v-if="next.video_time" @click="replay" class="c-study-video-autoNext-replay">重新观看</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index'
import ChimeeMobilePlayer from 'chimee-mobile-player'
import '@/css/chimee-mobile.css'

export default {
  props: {
    current: {
      type: Object,
      default: null
    },
    chapters: {
      type: Array,
      default: null
    },
    currentChapterIndex: {
      type: Number,
      default: null
    },
    currentSegmentIndex: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      showAutoNext: false,
      chimee: null,
      fixFristAutoPlayCount: 0,
      isLast: false,
      next: null,
      timer: null
    }
  },
  methods: {
    fixFristAutoPlay () {
      this.chimee.play()
      if (this.chimee.currentTime === 0 && this.fixFristAutoPlayCount <= 5) {
        setTimeout(this.fixFristAutoPlay, 1000)
        this.fixFristAutoPlayCount++
      }
    },
    getNextSegment () {
      let chapterIndex = this.currentChapterIndex
      let nextSegmentIndex = this.currentSegmentIndex + 1
      let chapter = this.chapters[chapterIndex]
      let nextSegment = chapter.listdata[nextSegmentIndex]
      if (chapter) {
        if (nextSegment) {
          this.next = nextSegment
        } else {
          if (chapter.onstatus === 0) {
            chapterIndex = chapterIndex + 1
            chapter = this.chapters[chapterIndex]
            nextSegmentIndex = 0
            nextSegment = chapter.listdata[nextSegmentIndex]
            this.next = nextSegment
          } else {
            this.next = {
              title: '阶段测试'
            }
          }
        }
      } else {
        // 如果是最后一节课
        return false
      }
    },
    replay () {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.chimee.currentTime = 0
      this.chimee.play()
    },
    async isPlayed (event) {
      if (event.target.currentTime > event.target.duration * .8) {
        api.updateProgress(this.$route.params.id, this.current.chapterorder, this.current.listorder)
        this.$emit('updateProgress')
        if (this.chimee) {
          this.chimee.off('timeupdate', this.isPlayed)
        }
      }
    }
  },
  watch: {
    current (){
      let self = this
      if (!this.current.videourl && this.chimee) {
        this.chimee.stopLoad()
        return false
      }
      if (!this.chimee && this.current.videourl) {
        let chimeePlayer = new ChimeeMobilePlayer({
          wrapper: '#c-study-video-wrapper',
          src: this.current.videourl,
          autoplay: false,
          controls: true,
          playsInline: true,
          preload: 'auto',
          x5VideoPlayerFullscreen: true,
          x5VideoOrientation: 'landscape|portrait',
          xWebkitAirplay: true,
          // muted: true,
          plugins: [
            {
              name: 'chimeeMobiControlbar',
              children: {
                play: {},
                currentTime: {},
                totalTime: {},
                progressBar: {},
                speed: {
                  tag: 'chimee-mobile-controlbar-speed',
                  html: `
                    <p data-value='1.00'>1.00x</p>
                  `,
                  event: {
                    tap (e) {
                      let speed = parseFloat(e.target.dataset.value) + 0.25
                      if (speed > 2) {
                        speed = 0.5
                      }
                      document.querySelector('#c-study-video-wrapper video').playbackRate = speed
                      let decimal = (speed + '').split('.')
                      let fill = 0
                      if (!decimal[1]) {
                        fill = '00'
                      } else {
                        if (decimal[1].length == 2) {
                          fill = decimal[1] + ''
                        } else {
                          fill = (decimal[1] + '') + '0'.repeat(2 - decimal[1].length)
                        }
                      }
                      e.target.innerText = decimal[0] + '.' + fill + 'x'
                      e.target.dataset.value = decimal[0] + '.' + fill
                    },
                  },
                },
                screen: {},
              }
            }
          ]
        })

        chimeePlayer.on('pause', (event) => {
          if (event.target.currentTime === event.target.duration && event.target.currentTime != 0) {
            const beforeNextChapter = this.current.chapterorder
            const beforeNextSegment = this.current.listorder
            this.getNextSegment()
            this.showAutoNext = true
            this.timer = setTimeout(() => {
              if (self.current.chapterorder === beforeNextChapter && self.current.listorder === beforeNextSegment) {
                this.$emit('next')
              }
            }, 5000)
          }
        })

        chimeePlayer.on('play', () => {
          this.showAutoNext = false
        })

        chimeePlayer.on('timeupdate', this.isPlayed)

        this.chimee = chimeePlayer
        this.fixFristAutoPlay()
      } else if (this.current.videourl) {
        if (this.chimee.currentSrc == this.current.videourl) {
          return
        }
        this.chimee.load(this.current.videourl)
        this.chimee.play()
        this.chimee.on('timeupdate', this.isPlayed)
      }
    }
  },
  beforeDestroy () {
    this.chimee.src = null
    this.chimee = null
  }
}
</script>

<style lang="scss" scoped>
.c-study-video{
  flex-basis: 100%;
  position: relative;
  .c-study-video-autoNext{
    width: 80%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    background-color: rgba(0, 0, 0, .85);
    text-align: center;
    box-sizing: border-box;
    padding: 20px 20px 16px 20px;
    color: #666666;
    border-radius: 5px;
    .c-study-video-autoNext-info{
      font-size: 14px;
      color: white;
      line-height: 24px;
      margin-bottom: 10px;
    }
    .c-study-video-autoNext-length{
      margin-left: 10px;
      color: #666666;
    }
    .c-study-video-autoNext-btn{
      width: 140px;
      height: 40px;
      background-color: #E63A38;
      font-size: 14px;
      color: white;
      border: none;
      border-radius: 2px;
      cursor: pointer;
      outline: none;
    }
    .c-study-video-autoNext-count{
      margin-top: 10px;
      font-size: 12px;
    }
    .c-study-video-autoNext-replay{
      margin-top: 16px;
      font-size: 13px;
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
#c-study-video-wrapper.m{
  chimee-control-wrap{
    height: 3em;
    line-height: 3em;
    .chimee-flex-component{
      height: 3em;
    }
    .chimee-progressbar-line{
      top: 50%;
      transform: translateY(-50%)
    }
    chimee-playbackrate.chimee-flex-component{
      font-size: 14px;
    }
    chimee-control-state,chimee-volume-state,chimee-screen-full,chimee-screen-small{
      height: 3em;
      position: relative;
      svg{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    chimee-mobile-controlbar-speed.chimee-flex-component{
      margin-right: .5em;
      color: white;
    }
  }
}
</style>
